import React from "react";
import _ from "lodash";
import Row from "@amzn/meridian/row";
import Table, { TableCell, TableRow } from "@amzn/meridian/table";
import Text from "@amzn/meridian/text";

const HEADER_COLUMN_WIDTH = 150;

interface IImportantDatesTableProps {
    data: any;
}

export const ImpDatesTable: React.FC<IImportantDatesTableProps> = ({ data }) => {
    const importantDates = _.get(
        data,
        "appealDetails.appealApproachCalculationData.summary.importantDates",
        {}
    );

    const dateEntries = Object.entries(importantDates);
    const midpoint = Math.ceil(dateEntries.length / 2);
    const leftColumnDates = dateEntries.slice(0, midpoint);
    const rightColumnDates = dateEntries.slice(midpoint);

    const getLabel = (key: string): string => _.startCase(key);

    const renderTable = (dates: any) => (
        <Table showDividers={true} spacing="small">
            {dates.map(([key, value]) => (
                <TableRow key={key}>
                    <TableCell width={HEADER_COLUMN_WIDTH} backgroundColor="secondary">
                        <Text type="h100">{getLabel(key)}</Text>
                    </TableCell>
                    <TableCell>{value || ""}</TableCell>
                </TableRow>
            ))}
        </Table>
    );

    return (
        <Row>
            {renderTable(leftColumnDates)}
            {renderTable(rightColumnDates)}
        </Row>
    );
};
